import { NavHorizontal } from "@/components/nav";
import type { NavProps } from "@/components/nav/types";
import { usePermissions } from "@/store/userStore";
import { ScrollBar } from "@/ui/scroll-area";
import { ScrollArea } from "@/ui/scroll-area";
import { cn } from "@/utils";
import { filterNavByPermissions } from "./filter-nav-by-permissions";

export function NavHorizontalLayout({ data }: NavProps) {
	const permissions = usePermissions();
	const filteredData = filterNavByPermissions(data, permissions ?? []);
	return (
		<nav
			data-slot="slash-layout-nav"
			className={cn(
				"w-screen bg-background z-app-bar",
				"sticky top-[var(--layout-header-height)] left-0 grow-0 shrink-0",
			)}
		>
			<ScrollArea className="min-w-screen whitespace-nowrap px-2 bg-background">
				<NavHorizontal data={filteredData} />
				<ScrollBar orientation="horizontal" />
			</ScrollArea>
		</nav>
	);
}
